<template>
  <a-modal
    :visible="visible"
    title="Crear chatbot"
    :body-style="{ height: '590px' }"
    width="754px"
    :keyboard="false"
    centered
    :mask-closable="false"
    wrapClassName="create-chatbot-modal"
    @cancel="handleConfirmationClose"
  >
    <section class="steps">
      <!-- <CustomStepper
        :value="current"
        @update:value="current = $event"
        :items="steps"
        progress-dot
        readonly
      /> -->
      <a-steps progress-dot :current="current" :items="steps" />
    </section>

    <section class="section">
      <keep-alive>
        <component
          :key="view"
          :is="view"
          :showWarning="showWarning"
          ref="step"
          @disable="handleDisable"
          v-bind="currentProperties"
          @onShowConfirmationModal="handleShowModal"
          validateSchedules
          @handle-validate-schedules="handleValidateSchedules"
        />
      </keep-alive>
    </section>

    <template v-slot:footer>
      <a-button @click="handlePrevious" :disabled="loadingOk"> {{ cancelText }} </a-button>
      <a-button
        type="primary"
        id="chatbot-modal-primary-btn"
        :disabled="disabled || loadingOk"
        :loading="loadingOk"
        @click="handleOk"
      >
        {{ okText }}
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import CustomStepper from "@/app/shared/components/organisms/CustomStepper.vue";
import { defineComponent, createVNode } from "vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";

import StepType from "@/app/chatbots/components/steps/StepType.vue";
import StepInitial from "@/app/chatbots/components/steps/StepInitial.vue";
import StepChannelSelector from "@/app/chatbots/components/steps/StepChannelSelector.vue";
import StepConfigTime from "@/app/chatbots/components/steps/StepConfigTime.vue";
import StepTimeout from "@/app/chatbots/components/steps/StepTimeout.vue";

import { BotType } from "@/app/chatbots/utils/enums";
import { ChannelType } from "@/app/shared/utils/enums";
import { validateChannelCustomerSchedule } from "../../services";

const steps = [
  { title: "Canales" },
  { title: "Datos básicos" },
  { title: "Horarios" },
  { title: "Identificadores" },
  { title: "Tiempo de espera" },
];

const initialStep = 0;
const lastStep = steps.length - 1;

export default defineComponent({
  components: {
    CustomStepper,
    StepInitial,
    StepChannelSelector,
    StepConfigTime,
    StepType,
    StepTimeout,
  },
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      current: initialStep,
      steps,
      campaigns: [],
      lastStep,
      initialStep,
      disabled: true,
      showConfirmModal: false,
      componentKey: 0,
      formState: {},
      showWarning: false,
      loadingOk: false,
    };
  },
  computed: {
    currentProperties() {
      return { isActive: true, isEdit: false, selectedChannel: this.formState.selectedChannel };
    },
    view() {
      const views = [
        "step-type",
        "step-initial",
        "step-config-time",
        "step-channel-selector",
        "step-timeout",
      ];
      return views[this.current];
    },
    okText() {
      if (this.current === lastStep) return "Finalizar";
      return "Continuar";
    },
    cancelText() {
      if (this.current === initialStep) return "Cancelar";
      return "Volver";
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.current = initialStep;
    },
    formatFormState(formState) {
      const {
        name,
        description,
        arrayRangePickers,
        channels_customers,
        selectedChannel,
        wait_time_action,
        timer,
        timer_message,
        queue,
        portfolio,
      } = formState;

      const formattedHours = arrayRangePickers.flatMap((range) => {
        const weekday = range.day;
        const hours = range.hours.map((hour) => {
          const start_hour = hour?.start ? `${hour.start.substring(0, 5)}:00` : null;
          const end_hour = hour?.end ? `${hour.end.substring(0, 5)}:59` : null;

          return {
            weekday,
            start_hour,
            end_hour,
          };
        });

        return hours;
      });

      return {
        name,
        description,
        schedules: formattedHours,
        channels_customers,
        channel: selectedChannel === ChannelType.Multichannel ? undefined : selectedChannel,
        type_bot:
          selectedChannel === ChannelType.Multichannel ? BotType.MultiChannel : BotType.MonoChannel,
        wait_time_action,
        timer,
        timer_message,
        queue,
        portfolio,
      };
    },
    async handleOk() {
      try {
        this.loading = true;
        const current = await this.$refs.step.handleOk(this.current);
        this.loading = false;
        this.formState = { ...this.formState, ...this.$refs.step.formState };
        if (current == null) this.handleClose();
        if (current == this.lastStep + 1) {
          const body = this.formatFormState(this.formState);

          const chatbot = await this.$store.dispatch("createChatbot", body);
          // this.$emit("update");
          this.$message.success(`Se ha creado el chatbot correctamente `);
          this.handleClose();

          this.$router.push(`/flows/chatbots/tree/${chatbot.id}`);
        }
        this.current = current;
      } catch (error) {
        console.error(error);
        const errorMessage =
          error?.getErrorMessage() || "Algo salió mal, por favor, vuelve a intentarlo";
        this.$message.warning(errorMessage);
        // this.showWarning = true;
      }
    },
    handleValidateSchedules(channel_customers) {
      const body = this.formatFormState(this.formState);

      validateChannelCustomerSchedule({ channel_customers, schedules: body.schedules })
          .then((response) => {
            if (response && response.length > 0) {
              this.showWarning = true;
            } else {
              this.showWarning = false;
            }
          })
          .catch(() => {
          });
    },
    handlePrevious() {
      if (this.current === 0) {
        this.handleConfirmationClose();
      } else {
        this.current = this.current - 1;
      }
    },
    handleDisable(value) {
      this.disabled = value;
    },
    handleCancel() {
      this.handleConfirmationClose();
    },
    handleClose() {
      this.$emit("closeModal");
      this.current = 0;
      this.loading = false;
    },
    handleShowModal() {
      this.showConfirmModal = true;
    },
    handleConfirmationClose() {
      if (this.showConfirmModal) {
        Modal.confirm({
          title: "¿Deseas descartar los cambios realizados?",
          content: "Recuerda que si no guardas los cambios registrados, estos se perderán.",
          width: 450,
          icon: createVNode(QuestionCircleOutlined),
          onOk: () => this.handleClose(),
          centered: true,
          okText: "Sí, descartar cambios",
          cancelText: "No, seguir editando",
        });
      } else {
        this.handleClose();
      }
    },
  },
});
</script>

<style lang="sass" scoped>
.steps
  margin: 24px 0

.section
  height: calc(100% - 80px)
  margin: 0 40px
</style>
